/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".resetPasswordButton[_ngcontent-%COMP%]{height:44px}  .lg-modal{width:30%!important;min-width:30!important}.mat-card-avatar[_ngcontent-%COMP%]{height:250px;width:250px;border-radius:50%;flex-shrink:0;-o-object-fit:cover;object-fit:cover}"];
export { styles as styles };
